export const messages = {
  en: {
    allocationStorehouseDetailed: {
      queryCondition: 'Query Condition',
      allocationDetail: 'Allocation Detail',
      query: 'Query',
      reset: 'Reset',
      more: 'More',
      hide: 'Hide',
      export: 'Export',
      all: 'All',
      resIdPlaceholder: 'Please input resource ID',
      resNamePlaceholder: 'Please input resource name',
      resTypePlaceholder: 'Please select resource type',
      secondTypePlaceholder: 'Please select secondary type',
      specPlaceholder: 'Please select specification',
      applyIdPlaceholder: 'Please input allocation ID',
      sourceStorePlaceholder: 'Required, please select source storehouse',
      targetStorePlaceholder: 'Required, please select target storehouse',
      startTimePlaceholder: 'Please select start time',
      endTimePlaceholder: 'Please select end time',
      statePlaceholder: 'Please select allocation state',
      exportSuccess: 'Export success',
      exportError: 'Export failed',
      table: {
        applyId: 'Allocation ID',
        resId: 'Resource ID',
        resType: 'Resource Type',
        resName: 'Resource Name',
        specName: 'Specification',
        isFixedName: 'Fixed Resource',
        originalStock: 'Original Stock',
        stock: 'Allocation Quantity',
        shaName: 'Source Storehouse',
        shzName: 'Target Storehouse',
        startUserName: 'Applicant',
        remark: 'Allocation Remark',
        state: 'Status',
        createTime: 'Time'
      }
    }
  },
  zh: {
    allocationStorehouseDetailed: {
      queryCondition: '查询条件',
      allocationDetail: '调拨明细',
      query: '查询',
      reset: '重置',
      more: '更多',
      hide: '隐藏',
      export: '导出',
      all: '全部',
      resIdPlaceholder: '请输入物品ID',
      resNamePlaceholder: '请输入物品名称',
      resTypePlaceholder: '请选择物品类型',
      secondTypePlaceholder: '请选择二级分类',
      specPlaceholder: '请选择物品规格',
      applyIdPlaceholder: '请输入调拨申请ID',
      sourceStorePlaceholder: '必填，请选择源仓库',
      targetStorePlaceholder: '必填，请选择目标仓库',
      startTimePlaceholder: '请选择开始时间',
      endTimePlaceholder: '请选择结束时间',
      statePlaceholder: '请选择调拨状态',
      exportSuccess: '导出成功',
      exportError: '导出失败',
      table: {
        applyId: '调拨单号',
        resId: '物品ID',
        resType: '物品类型',
        resName: '物品名称',
        specName: '物品规格',
        isFixedName: '固定物品',
        originalStock: '被调仓库原库存',
        stock: '调拨数量',
        shaName: '被调仓库',
        shzName: '目标仓库',
        startUserName: '申请人',
        remark: '调拨备注',
        state: '状态',
createTime: '时间'
      }
    }
  },
  'zh-TW': {
    allocationStorehouseDetailed: {
      queryCondition: '查詢條件',
      allocationDetail: '調撥明細',
      query: '查詢',
      reset: '重設',
      more: '更多',
      hide: '隱藏',
      export: '導出',
      all: '全部',
      resIdPlaceholder: '請輸入物品ID',
      resNamePlaceholder: '請輸入物品名稱',
      resTypePlaceholder: '請選擇物品類型',
      secondTypePlaceholder: '請選擇二級分類',
      specPlaceholder: '請選擇物品規格',
      applyIdPlaceholder: '請輸入調撥申請ID',
      sourceStorePlaceholder: '必填，請選擇源倉庫',
      targetStorePlaceholder: '必填，請選擇目標倉庫',
      startTimePlaceholder: '請選擇開始時間',
      endTimePlaceholder: '請選擇結束時間',
      statePlaceholder: '請選擇調撥狀態',
      exportSuccess: '導出成功',
      exportError: '導出失敗',
      table: {
        applyId: '調撥單號',
        resId: '物品ID',
        resType: '物品類型',
        resName: '物品名稱',
        specName: '物品規格',
        isFixedName: '固定物品',
        originalStock: '被調倉庫原庫存',
        stock: '調撥數量',
        shaName: '被調倉庫',
        shzName: '目標倉庫',
        startUserName: '申請人',
        remark: '調撥備註',
        state: '狀態',
        createTime: '時間'
      }
    }
  }
}